export const ROTATION_X_THRESHOLD = 5
export const ROTATION_Y_THRESHOLD = 5
export const EYE_OPEN_THRESHOLD = 0.8
export const BUFFER_SIZE = 15
export const VARIANCE_THRESHOLD = 0.6
export const STABLE_FOR_MS = 1000
export const SAMPLE_DURATION_MS = 3000
